import React from "react";
import { ASSESSMENT_TYPES } from "../constants/assessmentTypes";

const SelectTypePage = ({ onSelect }) => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      minHeight: "calc(100vh - 80px)",
    }}
  >
    <div
      style={{
        background: "white",
        borderRadius: "4px",
        overflow: "hidden",
        width: "320px",
        boxShadow: "0 4px 28px rgba(0,0,0,0.35)",
      }}
    >
      {/* Header */}
      <div
        style={{
          background: "#bb1ccc",
          color: "white",
          padding: "16px 20px",
          fontSize: "18px",
          fontWeight: "500",
          textAlign: "center",
        }}
      >
        Maturity Assessment Type
      </div>

      {/* List */}
      {ASSESSMENT_TYPES.map((type, i) => (
        <div key={type.value}>
          <div
            onClick={() => onSelect(type.value)}
            style={{ padding: "14px 20px", cursor: "pointer", color: "#222", fontSize: "15px" }}
            onMouseEnter={(e) => (e.currentTarget.style.background = "#f0f4ff")}
            onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
          >
            {type.label}
          </div>
          {i < ASSESSMENT_TYPES.length - 1 && (
            <hr style={{ margin: 0, border: "none", borderTop: "1px solid #bb1ccc" }} />
          )}
        </div>
      ))}

      {/* Footer bar */}
      <div style={{ background: "#bb1ccc", height: "12px" }} />
    </div>
  </div>
);

export default SelectTypePage;